<header
  class="sticky top-0 flex w-full bg-white border-gray-200 z-999 dark:border-gray-800 dark:bg-gray-900 xl:border-b">
  <div class="flex flex-col items-center justify-between grow xl:flex-row xl:px-6">
    <div
      class="flex items-center justify-between w-full gap-2 px-3 py-3 border-b border-gray-200 dark:border-gray-800 sm:gap-4 xl:justify-normal xl:border-b-0 xl:px-0 lg:py-4">
      <button
        class="items-center justify-center w-10 h-10 text-gray-500 border-gray-200 rounded-lg z-999 dark:border-gray-800 flex dark:text-gray-400 lg:h-11 lg:w-11 xl:border"
        [ngClass]="{
          'bg-gray-100 dark:bg-white/[0.03]': isMobileOpen$ | async,
        }" (click)="handleToggle()" aria-label="Toggle Sidebar">
        @if (isMobileOpen$ | async) {
        <!-- Cross Icon -->
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M6.21967 7.28131C5.92678 6.98841 5.92678 6.51354 6.21967 6.22065C6.51256 5.92775 6.98744 5.92775 7.28033 6.22065L11.999 10.9393L16.7176 6.22078C17.0105 5.92789 17.4854 5.92788 17.7782 6.22078C18.0711 6.51367 18.0711 6.98855 17.7782 7.28144L13.0597 12L17.7782 16.7186C18.0711 17.0115 18.0711 17.4863 17.7782 17.7792C17.4854 18.0721 17.0105 18.0721 16.7176 17.7792L11.999 13.0607L7.28033 17.7794C6.98744 18.0722 6.51256 18.0722 6.21967 17.7794C5.92678 17.4865 5.92678 17.0116 6.21967 16.7187L10.9384 12L6.21967 7.28131Z"
            fill="currentColor" />
        </svg>
        } @else {
        <!-- Hamburger Icon -->
        <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M0.583252 1C0.583252 0.585788 0.919038 0.25 1.33325 0.25H14.6666C15.0808 0.25 15.4166 0.585786 15.4166 1C15.4166 1.41421 15.0808 1.75 14.6666 1.75L1.33325 1.75C0.919038 1.75 0.583252 1.41422 0.583252 1ZM0.583252 11C0.583252 10.5858 0.919038 10.25 1.33325 10.25L14.6666 10.25C15.0808 10.25 15.4166 10.5858 15.4166 11C15.4166 11.4142 15.0808 11.75 14.6666 11.75L1.33325 11.75C0.919038 11.75 0.583252 11.4142 0.583252 11ZM1.33325 5.25C0.919038 5.25 0.583252 5.58579 0.583252 6C0.583252 6.41421 0.919038 6.75 1.33325 6.75L7.99992 6.75C8.41413 6.75 8.74992 6.41421 8.74992 6C8.74992 5.58579 8.41413 5.25 7.99992 5.25L1.33325 5.25Z"
            fill="currentColor" />
        </svg>
        }
      </button>
      <!-- Logo (placeholder) -->
      <a routerLink="/" class="xl:hidden">
        <img class="dark:hidden" width="25%" src="/images/logo/logo.png" alt="Logo" />
        <img class="hidden dark:block" width="25%" src="/images/logo/logo.png" alt="Logo" />
      </a>
      <button (click)="toggleApplicationMenu()"
        class="flex items-center justify-center w-10 h-10 text-gray-700 rounded-lg z-999 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 xl:hidden">
        <!-- Dots Icon -->
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M5.99902 10.4951C6.82745 10.4951 7.49902 11.1667 7.49902 11.9951V12.0051C7.49902 12.8335 6.82745 13.5051 5.99902 13.5051C5.1706 13.5051 4.49902 12.8335 4.49902 12.0051V11.9951C4.49902 11.1667 5.1706 10.4951 5.99902 10.4951ZM17.999 10.4951C18.8275 10.4951 19.499 11.1667 19.499 11.9951V12.0051C19.499 12.8335 18.8275 13.5051 17.999 13.5051C17.1706 13.5051 16.499 12.8335 16.499 12.0051V11.9951C16.499 11.1667 17.1706 10.4951 17.999 10.4951ZM13.499 11.9951C13.499 11.1667 12.8275 10.4951 11.999 10.4951C11.1706 10.4951 10.499 11.1667 10.499 11.9951V12.0051C10.499 12.8335 11.1706 13.5051 11.999 13.5051C12.8275 13.5051 13.499 12.8335 13.499 12.0051V11.9951Z"
            fill="currentColor" />
        </svg>
      </button>
    </div>
    <div [ngClass]="isApplicationMenuOpen ? 'flex' : 'hidden'"
      class="items-center justify-between w-full gap-4 px-5 py-4 xl:flex shadow-theme-md xl:justify-end xl:px-0 xl:shadow-none">
      <div class="flex items-center gap-2 2xsm:gap-3">
        <!-- Modo de envío SUNAT -->
        @if (configLoaded) {
        <div class="flex items-center gap-2 text-sm font-medium text-gray-600 dark:text-gray-400">
          <span [class.font-semibold]="!isOnlineMode" [class.text-gray-800]="!isOnlineMode"
            [class.dark:text-white]="!isOnlineMode">Offline</span>
          <app-switch label="Online" [defaultChecked]="isOnlineMode" (valueChange)="onModeChange($event)" />
        </div>
        }
        <!-- ThemeToggleButton placeholder -->
        <app-theme-toggle-button />
      </div>
      <!-- UserDropdown placeholder -->
      <app-user-dropdown />
    </div>
  </div>
</header>

<!-- MODAL: Configuración de intervalos OFFLINE -->
<app-modal [isOpen]="showOfflineModal" [className]="'max-w-3xl p-6 sm:p-8'" (close)="cancelOfflineConfig()">

  <div class="mb-6">
    <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Configurar modo Offline</h3>
    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
      Selecciona el intervalo de envío para cada tipo de comprobante.
    </p>
  </div>

  <div class="grid grid-cols-2 gap-4 sm:grid-cols-5">
    @for (doc of docTypeLabels; track doc.key) {
    <div>
      <app-label>{{ doc.label }}</app-label>
      <app-select
        [options]="intervalOptions"
        [value]="intervals[doc.key]"
        (valueChange)="intervals[doc.key] = $event">
      </app-select>
    </div>
    }
  </div>

  <div class="mt-6 flex justify-end gap-3">
    <app-button variant="outline" (btnClick)="cancelOfflineConfig()" [disabled]="savingConfig">
      Cancelar
    </app-button>
    <app-button variant="primary" (btnClick)="confirmOfflineConfig()" [disabled]="savingConfig">
      {{ savingConfig ? 'Guardando...' : 'Confirmar' }}
    </app-button>
  </div>

</app-modal>
